
import { flashErrorMessage } from '../../actions/flash';

export const validateForm = (store, validations) => {
  const errors = validations.filter(v => !v.isValid);
  const isError = errors.length > 0;
  if (isError) {
    store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
  }
  return isError;
};



// WEBPACK FOOTER //
// ./src/utils/validations/index.js